import { FC, useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../components/Loader';

interface IProps {
  visible: boolean;
  step: 'FIRST' | 'FIRST-FAIL' | 'SECOND' | 'SECOND-FAIL' | 'SECOND-VAN-FAIL' | 'THIRD' | 'THIRD-FAIL' | 'COMPLETE' | 'CANCEL';
  errorMessage?: string;

  onCancel(): void;

  onReset(): void;

  onReStart(): void;
}

const PaymentChangePosProcessModal: FC<IProps> = ({
                                                    visible,
                                                    step,
                                                    errorMessage,
                                                    onCancel,
                                                    onReset,
                                                    onReStart,
                                                  }) => {
  const { t } = useTranslation();

  const [isPaymentFail, setIsPaymentFail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, []);

  const onLocalCancel = () => {
    isPaymentFail && onCancel();
  };

  const buttonRender = () => {
    switch (step) {
      case 'FIRST-FAIL':
      case 'COMPLETE':
      case 'CANCEL':
        return (
          <Button key="cancel" className="btn-basic pink" onClick={onCancel}>
            {t('common.button.confirm')}
          </Button>
        );
      case 'SECOND-VAN-FAIL':
      case 'SECOND-FAIL':
        return (
          <>
            <Button key="cancel" className="btn-basic pink" onClick={onReStart}>
              {t('common.button.confirm')}
            </Button>

            <Button key="cancel" className="btn-basic gray" onClick={onReset}>
              {t('common.button.cancel')}
            </Button>
          </>
        );
      case 'THIRD-FAIL':
        return (
          <>
            <Button key="cancel" className="btn-basic pink" onClick={onReset}>
              {t('common.button.confirm')}
            </Button>

            <Button key="cancel" className="btn-basic gray" onClick={onCancel}>
              {t('common.button.cancel')}
            </Button>
          </>
        );
    }
  };

  const messageRender = () => {
    switch (step) {
      case 'FIRST':
        return (
          <>
            <p>변경할 카드를 삽입해주세요</p>
          </>
        );
      case 'SECOND':
        return (
          <>
            <p>변경할 카드로 결제 완료되었습니다.</p>
            <p>취소될 기존 결제카드를 삽입해 주세요</p>
          </>
        );
      case 'FIRST-FAIL':
      case 'CANCEL':
        return (
          <>
            <p>결제카드변경이 취소되었습니다.</p>
          </>
        );
      case 'SECOND-FAIL':
      case 'THIRD-FAIL':
        return (
          <>
            <p>카드 정보가 유효하지 않습니다.</p>
            <p>다시 시도하시겠습니까?</p>
          </>
        );
      case 'SECOND-VAN-FAIL':
        return (
          <>
            <p>환불에 실패 했습니다.</p>
            <p>다시 시도하시겠습니까?</p>
          </>
        );
      case 'THIRD':
        return (
          <>
            <p>결제카드 변경을 취소합니다.</p>
            <p>변경 카드를 삽입해 주세요</p>
          </>
        );
      case 'COMPLETE':
        return (
          <>
            <p>결제카드변경이 완료되었습니다.</p>
          </>
        );
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        title={t('student.student.button18')}
        visible={visible}
        onCancel={onLocalCancel}
        width={600}
        closeIcon={<AiOutlineClose onClick={onLocalCancel} />}
        footer={[
          <div className="comm-btn__area justify-content-center">
            {buttonRender()}
          </div>,
        ]}
      >
        <div className="text-center">
          {messageRender()}
        </div>
      </Modal>
    </>
  );
};

export default PaymentChangePosProcessModal;
